import type { RouteRecordRaw } from 'vue-router';
import { RouteNames } from '@/router/config/route-names'

export const asyncRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    redirect: '/switch',
    meta: { roles: ['admin','user'] },
    children: [
      {
        path: 'switch',
        name: RouteNames.Switch,
        component: () => import('@/views/login/switch.vue'),
        meta: { 
          title: 'menu.switch', 
          icon: 'Switch', 
          roles: ['admin', 'user'],
          requiresAuth: false,
        }
      },
      {
        path: '/interview_invitation',
        name: 'interviewInvitation',
        component: () => import('@/views/interview_invitation/index.vue'),
        meta: { title: 'menu.interviewInvitation', icon: 'List', roles: ['admin'] }
      },
      {
        path: 'account-center',
        name: RouteNames.AccountCenter,
        component: () => import('@/views/account-center/index.vue'),
        meta: { title: 'menu.accountCenter', icon: 'User', requiresAuth: true }
      },
      {
        path: '/company',
        name: RouteNames.Company,
        component: () => import('@/views/company/index.vue'),
        meta: { title: 'menu.companyManagement', icon: 'List', roles: ['admin'] }
      },
      {
        path: '/company-agent',
        name: RouteNames.CompanyAgent,
        component: () => import('@/views/company-agent/index.vue'),
        meta: { title: 'menu.companyManagement', icon: 'List', roles: ['admin'] }
      },
      // {
      //   path: '/terms-of-service',
      //   name: 'TermsOfService',
      //   component: () => import('@/views/terms-of-service/index.vue'),
      //   meta: { title: '利用規約', icon: 'Document', roles: ['admin', 'user'] }
      // },
    ]
  },
  {
    path: '/403',
    name: 'Error403',
    component: () => import('@/views/error/403.vue'),
    meta: { hidden: true, title: 'menu.error403', requiresAuth: false }
  },
  {
    path: '/404',
    name: 'Error404',
    component: () => import('@/views/error/404.vue'),
    meta: { hidden: true, title: 'menu.error404', requiresAuth: false }
  },
  { path: '/:pathMatch(.*)*', redirect: '/404', meta: { hidden: true, requiresAuth: false } }
];
